// src/components/invoices/DownloadAgentButton.jsx
import React from 'react';
import { Icon } from '../ui';

const DownloadAgentButton = () => {
  // Utilise la variable d'environnement ou localhost par défaut
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  
  // Le lien pointe vers le dossier statique configuré dans le backend
  const downloadLink = `${API_URL}/api/downloads/kit-signature`;

  return (
    <a
      href={downloadLink}
      download
      className="btn bg-indigo-600 text-white hover:bg-indigo-700 flex items-center px-4 py-2 rounded-lg transition-colors shadow-sm text-sm font-medium"
      title="Télécharger l'agent local de signature (Windows)"
    >
      <Icon name="IconDeviceLaptop" className="mr-2" />
      <span>Kit Signature</span>
    </a>
  );
};

export default DownloadAgentButton;
